/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { FC } from 'react';

import Text from 'components/styled/Text';
import { Wrapper, ResponsivePadder } from 'components/styled/Wrapper';
import TileGrid from 'components/tilegrid';
import OfferSearchItem from 'components/tiles/offer/OfferSearchItem';

import { useNewestOffers } from 'api/publicApi';
import { Backend } from 'api/endpoints';

import { useLocalizedMultistring } from 'utils/localization';

const NewestOffers: FC = () => {
	const localize = useLocalizedMultistring();

	const response = useNewestOffers();
	const offers = ((response.data ?? []) as unknown) as Backend.OfferDetail[];
	// do not show anything if there are no offers
	// also avoid displaying any error messages, that would be to the detriment of the UX
	{
		response.isSuccess && offers.length <= 0 && <></>;
	}
	return (
		<>
			{response.isSuccess && offers.length > 0 && (
				<Wrapper bg="lightGrey" minHeight={300} py={5}>
					<ResponsivePadder textAlign={['center', 'left']} pb={2}>
						<Text
							color="primary"
							fontSize="lg"
							fontWeight="700"
							mt={0}
							mb={4}
							css={css`
								text-transform: uppercase;
							`}
						>
							{localize({
								CZECH: 'Nejnovější nabídky Job Portalu',
								ENGLISH: 'The latest Job Portal offers',
							})}
						</Text>
						<TileGrid isEmpty={false}>
							{offers.slice(0, 3).map(o => (
								<OfferSearchItem key={o.id} variant="search" isPublic {...o} />
							))}
						</TileGrid>
					</ResponsivePadder>
				</Wrapper>
			)}
		</>
	);
};
export default NewestOffers;
